export const hasOwn = (obj: object | null | undefined, key: PropertyKey | null | undefined) =>
  obj != null && key != null && Object.prototype.hasOwnProperty.call(obj, key);
